const Pos = [
  {
    id: '1',
    name: 'pos-1',
    title: 'Mesin Kasir Version 2',
    desc: 'Mesin kasir termurah untuk toko minimarket.',
    video: 'https://youtube.com/embed/9HYHptO36A4',
    img: 'https://kasironline.github.io/pos/mkvc/TOUCHSCREEN2.webp',
    date: '03-01-2023',
    order:
      'https://www.axcora.com/shop#!/MESIN-KASIR-TOUCHSCREEN-VERSION-2/p/138771988/category=42880013',
    price: 'Rp.10.000.000',
    content: [
      `PC all in one touchscreen windows by ASUS + Printer kasir thermal auto cutter + Software kasir retail / resto cafe`,
    ],
  },
  {
    id: '2',
    name: 'pos-2',
    title: 'Mesin Kasir Version 3',
    desc: 'Mesin kasir lengkap dan hemat untuk resto cafe rumah makan.',
    video: 'https://youtube.com/embed/gGZcHO32mh4',
    img: 'https://kasironline.github.io/pos/mkvc/TOUCHSCREEN3.webp',
    date: '03-01-2023',
    price: 'Rp.11.000.000',
    order:
      'https://www.axcora.com/shop#!/MESIN-KASIR-TOUCHSCREEN-VERSION-3/p/138803014/category=42880013',
    content: [
      `PC all in one touchscreen windows by ASUS + Printer kasir thermal auto cutter + laci kasir besi + Software kasir retail / resto cafe`,
    ],
  },
  {
    id: '3',
    name: 'pos-3',
    title: 'Mesin Kasir Version 4',
    desc: 'Mesin kasir barcode termurah untuk toko minimarket retail.',
    video: 'https://youtube.com/embed/jYKUiC6NXj4',
    img: 'https://kasironline.github.io/pos/mkvc/TOUCHSCREEN4.webp',
    date: '03-01-2023',
    price: 'Rp.12.000.000',
    order:
      'https://www.axcora.com/shop#!/MESIN-KASIR-TOUCHSCREEN-VERSION-4/p/138803073/category=42880013',
    content: [
      `PC all in one touchscreen windows by ASUS + Printer kasir thermal auto cutter + laci kasir besi + Laser barcode manual single laser system + Software kasir retail / resto cafe`,
    ],
  },
  {
    id: '4',
    name: 'pos-4',
    title: 'Mesin Kasir Version 5',
    desc: 'Mesin kasir termurah untuk toko minimarket.',
    video: 'https://youtube.com/embed/zQIjZPnGthc',
    img: 'https://kasironline.github.io/pos/mkvc/TOUCHSCREEN5.webp',
    date: '03-01-2023',
    price: 'Rp.14.500.000',
    order:
      'https://www.axcora.com/shop#!/MESIN-KASIR-TOUCHSCREEN-VERSION-5/p/138803096/category=42880013',
    content: [
      `PC all in one touchscreen windows by ASUS + Printer kasir thermal auto cutter + laci kasir besi + Laser barcode multi auto laser system + Software kasir retail / resto cafe`,
    ],
  },
  {
    id: '5',
    name: 'pos-5',
    title: 'Mesin Kasir Version 6',
    desc: 'Mesin kasir barcode lengkap untuk toko minimarket.',
    video: 'https://youtube.com/embed/hzXc74f5KP8',
    img: 'https://kasironline.github.io/pos/mkvc/TOUCHSCREEN6.webp',
    date: '03-01-2023',
    price: 'Rp.18.500.000',
    order:
      'https://www.axcora.com/shop#!/MESIN-KASIR-TOUCHSCREEN-VERSION-6/p/138803100/category=42880013',
    content: [
      `PC all in one touchscreen windows by ASUS + Printer kasir thermal auto cutter + laci kasir besi + Laser barcode multi auto laser system + Mesin Barcode + Software kasir retail / resto cafe`,
    ],
  },
];

export default Pos;
